var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 53.5C30.067 53.5 28.5 51.933 28.5 50C28.5 48.067 30.067 46.5 32 46.5C33.933 46.5 35.5 48.067 35.5 50C35.5 51.933 33.933 53.5 32 53.5Z",
    stroke: "#4F8CE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4467 9.5H34.6199C36.678 9.5 38.2918 11.2672 38.1055 13.3169L35.8328 38.3169C35.6689 40.1197 34.1574 41.5 32.3471 41.5H32.0982C30.3081 41.5 28.8065 40.1493 28.6177 38.3691L25.9662 13.3691C25.7469 11.3017 27.3676 9.5 29.4467 9.5Z",
    stroke: "#4F8CE8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportant);
export default __webpack_public_path__ + "static/media/important.e5fb799800a31828299e12aebbf81f3e.svg";
export { ForwardRef as ReactComponent };